import styled from 'styled-components'

type Props = {
  showSemiCircle: boolean
}

const ComponentStyled = styled.div<Props>`
  height: 200px;
  width: 100%;
  position: relative;

  #seed-animation {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 100%;
    height: 600px;
    width: 600px;
  }

  .plant {
    position: absolute;
    transition: 0.5s ease all;
    top: calc(-100% - 50px);

    .plant-img {
      position: relative;
      height: 316px;
      width: 230px;
    }

    &.pear-millet {
      top: calc(-100% - 41px);
      left: 0;
    }

    &.beans {
      left: ${({ showSemiCircle }) => (showSemiCircle ? '15%' : '25%')};
      transform: ${({ showSemiCircle }) => (showSemiCircle ? 'translateX(-15%)' : 'translateX(-25%)')};
    }

    &.lentils {
      left: 50%;
      transform: translateX(-50%);
      opacity: ${({ showSemiCircle }) => (showSemiCircle ? '0' : '1')};
    }

    &.sorghum {
      right: ${({ showSemiCircle }) => (showSemiCircle ? '15%' : '25%')};
      transform: ${({ showSemiCircle }) => (showSemiCircle ? 'translateX(15%)' : 'translateX(25%)')};
    }

    &.pea {
      right: 0;
    }
  }

  .semicircle {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: calc(-100% + 44px);
    opacity: ${({ showSemiCircle }) => (showSemiCircle ? '1' : '0')};
    transition: 0.5s ease all;

    .semicircle-img {
      position: relative;
      height: 314px;
      width: 314px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    height: 100px;
    display: flex;
    justify-content: center;

    #seed-animation {
      height: 200px;
      width: 200px;
    }

    .plant {
      top: calc(-100% - 3px);
      position: relative;

      .plant-img {
        height: 130px;
        width: 115px;
      }

      &.pear-millet {
        top: -100%;
      }

      &.pear-millet,
      &.beans,
      &.lentils,
      &.sorghum,
      &.pea {
        left: inherit;
        right: inherit;
        transform: inherit;
      }
    }

    .semicircle {
      top: calc(-100% + 55px);

      .semicircle-img {
        width: 180px;
        height: 90px;
      }
    }
  }
`

export default ComponentStyled
